module.exports = __webpack_public_path__ + "static/img/20231.5676dbc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/20231.jpg
// module id = xgGP
// module chunks = 1